import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import Checkbox from "@material-ui/core/Checkbox";
import { ReactComponent as Phone } from "./phone.svg";

class index extends Component {
  render() {
    const language = this.props.language;
    return (
        <div style={{marginTop: 30}}>
            <p
                className="box-title"
                style={{textAlign: language === "arabic" ? "right" : "left"}}
            >
                {language === "english" ? "Phone Number" : "رقم الهاتف"}
            </p>
      <div
        className="w-100"
        style={{
          backgroundColor: "white",
          height: !this.props.accountName ? 110 : 220,
          marginTop: 5
        }}
      >
        <p
          className={"pt-3 ".concat(
            language == "english" ? "text-left pl-3" : "text-right pr-3"
          )}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          <span
            style={{
              marginRight: language == "english" && 10,
              marginLeft: language == "arabic" && 10
            }}
          >
            <Phone style={{ width: 20, height: 20, color: "#333" }} />
          </span>
          {language == "english"
            ? "What's your phone number?"
            : "ما هو رقم هاتفك؟"}
        </p>
        <div className="mx-auto" style={{ width: "92%" }}>
          <TextField
            id="phoneNumberTextField"
            label={language == "english" ? "Phone number" : "رقم الهاتف"}
            color="primary"
            key={"phoneNumberKey"}
            name="phoneNumber"
            fullWidth
            error={this.props.phoneNumberError}
            value={this.props.phoneNumber}
            onChange={this.props.handlePhoneNumberChange}
            InputLabelProps={{
              style: {
                right: language == "arabic" && 5,
                left: language == "arabic" && "auto"
              },
              dir: language == "english" ? "ltr" : "rtl"
            }}
            InputProps={{
              dir: language == "english" ? "ltr" : "rtl"
            }}
          />
          {this.props.accountName ? (
            <>
              <p
                className={" ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
                dir={language == "english" ? "ltr" : "rtl"}
                style={{
                  marginTop: 30,
                  marginBottom: 0
                }}
              >
                {language == "english" ? "Account Name:" : "اسم الفرع:"}{" "}
                <span style={{ fontWeight: 600 }}>
                  {this.props.accountName}
                </span>
              </p>
              <p
                className={"mt-2 ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                {language == "english"
                  ? "Is this you?"
                  : "تأكيد على اسم الحساب"}
                <span className={language == "english" ? "ml-3" : "mr-3"}>
                  <Checkbox
                    checked={this.props.checkboxValue}
                    onChange={this.props.handleCheckbox}
                    value="primary"
                    color="primary"
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                </span>
                <span>{language == "english" ? "Yes" : "نعم"}</span>
              </p>
            </>
          ) : null}
        </div>
      </div>
         </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.store.language
  };
};
export default  connect(mapStateToProps)(index);
